import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { API_BASE_URL } from "./service-shared";
import { environment } from "environments/environment";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { blobToText, processProblemResponse } from "./service-functions";
import { DocumentGenerationResult } from "./model/doc-gen-service.model";

@Injectable({ providedIn: 'root' })
export class DocGenServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    private basePath: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.basePath = environment.config?.docgenEndpoint !== undefined ? environment.config.docgenEndpoint : '';
        this.baseUrl = (baseUrl !== undefined && baseUrl !== null ? baseUrl : "") + this.basePath;
    }

    /**
     * Generates PDF files according to Application Data and Document Generation control configuration.
     * @return The content for an HTML control.
     */
    generatePdf(applicationId: string, controlName: string, applicationData: { [key: string]: any }, path: string | undefined = null): Observable<void | DocumentGenerationResult> {
        let url_ = this.baseUrl + `/pdf/generatePdf/${applicationId}/${controlName}`;
        if (path) {
            url_ += "/" + path;
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationData);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGeneratePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(() => new Error(e)) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => new Error(response_)) as any as Observable<void>;
        }));
    }

    protected processGeneratePdf(response: HttpResponseBase): Observable<DocumentGenerationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DocumentGenerationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }

        return processProblemResponse(status, responseBlob, _headers, this.jsonParseReviver)
            ?? _observableOf<DocumentGenerationResult>(null as any);
    }

}
